import React from 'react';
import '../Assets/Css/mep.css';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

import aboutmep from '../Assets/Image/mepservices1.avif';
import hvac from '../Assets/Image/industrialmep.avif';
import electrical from '../Assets/Image/electricalmep.avif';
import firesafety from '../Assets/Image/Fire Fighting System.avif';
import mepcta from '../Assets/Image/mepservice3.avif';

import { Helmet } from 'react-helmet';

export default function MepService() {
  const testimonials = [
    {
      message: "Pradh's MEP team delivered flawless HVAC and electrical installations on time. Extremely professional and detail-oriented.",
      author: "Facility Manager",
    },
    {
      message: "Their integrated fire safety and plumbing systems have added immense value to our plant. We trust their expertise completely.",
      author: "Operations Head",
    },
    {
      message: "From planning to execution, their MEP services were efficient, safe, and up to code. Truly impressive work.",
      author: "Chief Engineer",
    },
  ];

 
const mepServices = [
  {
    id: 1,
    title: "Industrial & Commercial HVAC Installation",
    description:
      "We provide HVAC solutions tailored for large-scale facilities, including ductwork, chillers, AHUs, and ventilation systems. Our systems ensure thermal comfort, air purification, and optimal energy consumption.",
    image: hvac,
    works: [
      "Design and installation of HVAC systems",
      "Air handling units (AHUs) and ductwork",
      "Chillers, cooling towers, and VRF systems",
      "Routine maintenance and energy audits"
    ],
    benefits: [
      "Improved indoor air quality",
      "Energy-efficient operations",
      "Consistent temperature control",
      "Reduced maintenance downtime"
    ],
    applicationAreas: [
      "Industrial plants and factories",
      "Commercial buildings and offices",
      "Hospitals and laboratories",
      "Shopping malls and multiplexes"
    ]
  },
  {
    id: 2,
    title: "Electrical System Integration",
    description:
      "Our electrical services cover end-to-end installation—from load calculations, switchgear and cabling, to automation and energy optimization. We ensure seamless and safe power distribution for commercial and industrial operations.",
    image: electrical,
    works: [
      "Design and layout of electrical systems",
      "Cable routing, trunking, and panel installations",
      "Power distribution boards and switchgear setup",
      "Lighting, backup systems, and automation"
    ],
    benefits: [
      "Safe and reliable electrical networks",
      "Scalable power systems for future growth",
      "Reduced energy loss and downtime",
      "Compliance with electrical safety standards"
    ],
    applicationAreas: [
      "Manufacturing units",
      "Office complexes",
      "Educational institutions",
      "IT parks and data centers"
    ]
  },
  {
    id: 3,
    title: "Fire Fighting System",
    description:
      "We design and install complete fire safety systems including sprinklers, fire hydrants, suppression systems, alarm panels, and pumps. All setups meet NFPA and national safety standards for maximum protection.",
    image: firesafety,
    works: [
      "Installation of sprinklers and hydrants",
      "Fire alarm and detection systems",
      "Pumps and water supply configurations",
      "Fire suppression systems (gas/wet/dry)"
    ],
    benefits: [
      "Early detection and quick response to fire hazards",
      "Protection of life, assets, and infrastructure",
      "Compliance with fire safety norms and audits",
      "Customizable solutions for all building types"
    ],
    applicationAreas: [
      "Factories and warehouses",
      "Residential and commercial buildings",
      "Airports and metro stations",
      "Educational and healthcare facilities"
    ]
  }
];


  return (
    <div className="mainnav min-vh-100">
      <Helmet>
        {/* Basic SEO */}
        <title>MEP Services | HVAC, Electrical & Fire Safety Solutions - Pradh</title>
        <meta
          name="description"
          content="Pradh offers expert Mechanical, Electrical & Plumbing (MEP) services including HVAC installation, electrical systems, and fire safety. Reliable, efficient, and standards-compliant."
        />
        <meta
          name="keywords"
          content="MEP Services India, HVAC Installation, Electrical Integration, Fire Fighting Systems, Industrial MEP, Commercial HVAC, Fire Safety Solutions, MEP Contractors India, Pradh Management Solutions"
        />
        <meta name="author" content="Pradh Management Solutions" />
        <meta name="robots" content="index, follow" />

        {/* Open Graph / Facebook */}
        <meta property="og:title" content="MEP Services | HVAC, Electrical & Fire Systems - Pradh" />
        <meta
          property="og:description"
          content="Explore Pradh’s comprehensive MEP services: industrial HVAC systems, electrical installation, and fire safety integration for modern infrastructure."
        />
        <meta property="og:url" content="https://pradh.com/mep-services" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://pradh.com/images/mep-services-banner.jpg" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="MEP Services | HVAC, Electrical & Fire Safety Solutions - Pradh" />
        <meta
          name="twitter:description"
          content="Get reliable MEP solutions from Pradh: HVAC, fire fighting systems, electrical installations, and more for industrial and commercial buildings."
        />
        <meta name="twitter:image" content="https://pradh.com/images/mep-services-banner.jpg" />

        {/* Canonical */}
        <link rel="canonical" href="https://pradh.com/mep-services" />
      </Helmet>

      {/* Hero Section */}
      <section className="hero-sectioncivil">
        <div className="overlay text-center text-white d-flex flex-column justify-content-center align-items-center">
          <h1 data-aos="zoom-in">
            Mechanical, Electrical & Plumbing <br /> (MEP) Services
          </h1>
          <p data-aos="zoom-in" data-aos-delay="100">
            Integrated systems designed to power, protect, and support your infrastructure.
          </p>
          <a href="/contact" className="btn-get mt-3" data-aos="fade-up" data-aos-delay="100">
            Get in Touch
          </a>
        </div>
      </section>

      {/* Overview Section */}
      <section className="about-us py-5">
        <Container>
          <Row>
            <Col md={5} className="d-flex justify-content-center align-items-center">
              <img
                src={aboutmep}
                alt="About MEP Services"
                className="img-fluid aboutsecimg rounded shadow mb-3"
                data-aos="zoom-in"
                data-aos-delay="100"
              />
            </Col>
            <Col md={7}>
              <h2 className="page-title text-center mb-3" data-aos="fade-up">Overview</h2>
              <p data-aos="zoom-in" data-aos-delay="100">
                At <strong style={{ color: '#04A1D3' }}>Pradh Management Solutions</strong>, we deliver expert MEP services including HVAC, electrical systems, and fire safety. Our solutions are designed to meet the complex needs of modern industrial and commercial buildings.
              </p>
              <p data-aos="zoom-in" data-aos-delay="100">
                We ensure your building is not just operational but optimized for energy efficiency, safety, and long-term performance. All work is executed with strict compliance to national and international standards.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Our Services */}
      <section className="servicesmep-content py-5 ">
  <Container>
    <h2 className="page-title text-center mb-5" data-aos="fade-up">Our MEP Services</h2>
    {mepServices.map((service, index) => (
      <Row
        className=" mb-5 p-4"
        key={service.id}
        data-aos="fade-up"
        data-aos-delay={index * 100}
      >
        <Col
          md={5}
          // className={index % 2 === 0 ? 'order-md-1' : 'order-md-2'}
            className={`${index % 2 === 0 ? 'order-md-1' : 'order-md-2'} d-flex justify-content-center align-items-center`}
        >
          <img
            src={service.image}
            alt={service.title}
            className="img-fluid rounded shadow mb-3"
            style={{ maxHeight: '350px', objectFit: 'cover', width: '100%' }}
          />
        </Col>
        
 <Col md={7} className={index % 2 === 0 ? 'order-md-2' : 'order-md-1'}>
        <h3  className="mb-3 fw-bold text-center " style={{color:'#C52316'}}>{service.title}</h3>
        <p>{service.description}</p>
         <p>{service.works}</p>

        <Row>
          {/* Benefits */}
          <Col xs={12} md={6}>
            <h5 className="text-secondary mt-3">Benefits:</h5>
            <ul className="ps-3">
              {service.benefits.map((item, idx) => (
                <li key={idx}>{item}</li>
              ))}
            </ul>
          </Col>

          {/* Application Areas */}
          <Col xs={12} md={6}>
            <h5 className="text-secondary mt-3">Application Areas:</h5>
            <ul className="ps-3">
              {service.applicationAreas.map((item, idx) => (
                <li key={idx}>{item}</li>
              ))}
            </ul>
            
          </Col>
        </Row>
         <hr />
      </Col>

      </Row>
    ))}
   
  </Container>
</section>


      {/* CTA Section */}
      <section className="contact-cta py-4 text-center">
        <Container>
          <Row className="align-items-center">
            <Col md={6} className="text-center text-md-start mb-3" data-aos="zoom-in" data-aos-delay="100">
              <h2>Need Expert MEP Services?</h2>
              <p className="lead">
                From HVAC systems to fire safety and electrical installations,
                <strong> Pradh Management Solutions </strong>
                delivers quality, compliance, and consistency you can count on.
              </p>
              <a href="/contact" className="btn-get">Get in Touch</a>
            </Col>
            <Col md={6}>
              <div className="d-flex justify-content-center">
                <img
                  src={mepcta}
                  alt="MEP Services CTA"
                  className="img-fluid rounded shadow"
                  data-aos="zoom-in"
                  data-aos-delay="100"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Testimonials */}
      <section className="testimonials py-5 bg-light">
        <Container>
          <h2 className="page-title text-center" data-aos="fade-up">What Our Clients Say</h2>
          <Row>
            <Col md={{ span: 8, offset: 2 }}>
              <Swiper
                modules={[Autoplay, Pagination]}
                spaceBetween={30}
                slidesPerView={1}
                autoplay={{ delay: 5000 }}
                loop={true}
                pagination={{ clickable: true }}
              >
                {testimonials.map((testimonial, index) => (
                  <SwiperSlide key={index}>
                    <Card className="p-4 mb-4 border-0 text-center" data-aos="zoom-in" data-aos-delay="100">
                      <p>⭐️⭐️⭐️⭐️⭐️</p>
                      <p className="mb-3" style={{ fontStyle: 'italic' }}>“{testimonial.message}”</p>
                      <small className="text-muted">— {testimonial.author}</small>
                    </Card>
                  </SwiperSlide>
                ))}
              </Swiper>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
}
